import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Link from "../../link/component";

import * as styles from "./styles.module.scss";

const CardNav = ({ outline, image, title, text, link_text, url }) => {
  return outline ? (
    <Link
      to={url}
      className={classNames(styles.outline, {
        [styles.vertical]: outline == "vertical",
        [styles.horizontal]: outline == "horizontal"
      })}
    >
      {image && (
        <img src={image.data?.attributes?.url} alt={image.data?.attributes?.alt || title} />
      )}
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={classNames("card_nav_desc", styles.desc)}>{text}</div>
      </div>
    </Link>
  ) : (
    <div className={styles.borderless}>
      <div className={styles.title}>{title}</div>
      <div className={classNames("card_nav_desc", styles.desc)}>{text}</div>
      <Link to={url} className="btn">
        {link_text}
      </Link>
    </div>
  );
};

CardNav.propTypes = {
  outline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["horizontal", "vertical"])]),
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link_text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default CardNav;
